<expandable titulo="Gravação da Consulta" icone="hgi-computer-video" class="gravacao">

    <div class="video">
        <div class="info">
            <div class="logo">
                <i class="hgi hgi-stroke hgi-play-square"></i>
            </div>
            <div class="nome">
                Checkup-20-21-2025.mp4
            </div>
        </div>
        <div class="options">
            <button type="button" class="btn btn-outline-secondary">
                <i class="hgi hgi-stroke hgi-download-04"></i>
            </button>
        </div>
    </div>

    <div class="logs">
        <p class="log">
            <i class="hgi hgi-stroke hgi-clock-01"></i>
            Consulta realizada em 20/01/2025 - 16:45
        </p>
    </div>

</expandable>
